<template>
  <div>
    <h3 class="heading-3 weight-medium pb-10 pb-md-16 text-left text-md-center">
      What is your reason for seeking health insurance?
      <Tooltip>
        <p class="text-left m-0">
          
    <b>Change of health insurance provider</b> is indicated if the reason for the application is to switch from the current insurance provider to a different one.
    <br/>
    <br/>
    <b>Coming from abroad</b> is indicated if you want to take out public health insurance in the Slovak Republic, while:
    you have permanent residence in the Slovak Republic and have returned from abroad;
    you do not have permanent residence in the Slovak Republic and you have moved from abroad.
    <br/>
    <br/>
    <b>Childbirth</b> is indicated if you have recently had a baby and the baby does not have health insurance yet.
  
        </p>
      </Tooltip>
    </h3>

    <div class="input-box-holder" v-validate="errors" v-has-value="person.insuredPersonType">
      <div class="validation-output text-left mb-10">
        <ErrorHandler class="error" :id="`V001_${index}`">
          You have not selected any of the options. To continue, please select one option.
        </ErrorHandler>

        <ErrorHandler class="error" :id="`V002_${index}`">
          You have not selected any of the options. To continue, please select one option.
        </ErrorHandler>
      </div>

      <RadioButton v-for="option in insuranceTypeEnum"
        class="input-box rd-card mb-10 body-1"
        :title="option.label"
        :key="option.name$"
        :value="person.insuredPersonType"
        :option="option"
        :name="'insuranceTypeGroup' + index"
        :checked="isSelected(option)"
        @input="setInsuredPersonType"
      >
        <div v-if="isChangeOfInsuranceCompany && isSelected(option)">
          <div class="input-box-holder" v-validate="errors" v-has-value="person.previousInsuranceCompany">
            <p class="mt-2 mb-10">
              Current Health Insurance Provider
            </p>
            <div class="validation-output text-left mb-5">
              <ErrorHandler class="error" :id="`V003_${index}`">
                You have not selected any of the options. To continue, please select one option.
              </ErrorHandler>
            </div>
            <div class="flex gap-5">
              <RadioButton
                v-for="(option) in enumsValues.PreviousInsuranceCompanyEnum"
                class="input-box"
                :key="option.name$"
                :title="option.label"
                :option="option"
                :name="'previousInsuranceCompany' + index"
                v-model="person.previousInsuranceCompany"
              />
            </div>

            <InfoBox class="mt-10 pt-5 pl-5 pr-5 pb-2" :icon="require('@/assets/svg/sound-icon.svg')">
              <p class="body-3 weight-regular mr-0 ml-0 mb-0 mt-0">
                The change of health insurance provider will be effective from {{ formatDate(person.insuredFrom) }}.
              </p>
            </InfoBox>
          </div>
        </div>
      </RadioButton>
    </div>
  </div>
</template>

<script>
import { formatDateForKotlin, makeDateFromKotlin } from 'union_kotlin';
import RadioButton from '@/components/RadioButton/RadioButton.vue';
import distributionChannels from '@/mixins/distributionChannels';
import routes from '@/mixins/routes';
import GA from '@/mixins/GA';
import InfoBox from '@/components/InfoBox/InfoBox.vue';
import ErrorHandler from '@/components/ErrorHandler/ErrorHandler.vue';
import Tooltip from '@/components/Tooltip/Tooltip.vue';

export default {
  components: {
    RadioButton, InfoBox, ErrorHandler, Tooltip,
  },
  mixins: [distributionChannels, routes, GA],
  props: {
    person: { type: Object, required: true },
    model: { type: Object, required: true },
    errors: { type: Array, required: true },
    index: { type: Number, required: true },
  },
  computed: {
    insuredPersons() { return this.model.insuredPersons.array_hd7ov6$_0; },
    insuranceTypeEnum() {
      const { InsuredPersonTypeEnum: options } = this.enumsValues;
      const { InsuredPersonTypeEnum: enumeration, LocaleEnum } = this.enums;
      const originalInsuredPersonType = this.person.insuredPersonType;
      return options
        .filter((option) => {
          const { isAdult } = this.person;
          if (!isAdult && option === enumeration.BIRTH_OF_CHILD) {
            return true;
          }
          if (option === enumeration.CHANGE_OF_INSURANCE_COMPANY_ADULT) {
            if (isAdult && originalInsuredPersonType === enumeration.CHANGE_OF_INSURANCE_COMPANY_CHILD) {
              this.person.insuredPersonType = enumeration.CHANGE_OF_INSURANCE_COMPANY_ADULT;
            }
            return isAdult;
          }
          if (option === enumeration.RETURN_FROM_ABROAD_ADULT) {
            if (isAdult && originalInsuredPersonType === enumeration.RETURN_FROM_ABROAD_CHILD) {
              this.person.insuredPersonType = enumeration.RETURN_FROM_ABROAD_ADULT;
            }
            return isAdult;
          }
          if (option === enumeration.CHANGE_OF_INSURANCE_COMPANY_CHILD) {
            if (!isAdult && originalInsuredPersonType === enumeration.CHANGE_OF_INSURANCE_COMPANY_ADULT) {
              this.person.insuredPersonType = enumeration.CHANGE_OF_INSURANCE_COMPANY_CHILD;
            }
            return !isAdult;
          }
          if (!isAdult && originalInsuredPersonType === enumeration.RETURN_FROM_ABROAD_ADULT) {
            this.person.insuredPersonType = enumeration.RETURN_FROM_ABROAD_CHILD;
          }
          return !isAdult;
        })
        .map((option) => {
          if (!this.isVIP) return option;
          const { RETURN_FROM_ABROAD_ADULT, RETURN_FROM_ABROAD_CHILD } = enumeration;
          if (option === RETURN_FROM_ABROAD_ADULT || option === RETURN_FROM_ABROAD_CHILD) {
            if (this.model.locale === LocaleEnum.SK) option.label += '/Cudzinec';
            if (this.model.locale === LocaleEnum.EN) option.label += '/Foreigner';
            return option;
          }
          return option;
        });
    },
    today() { return makeDateFromKotlin(this.model.now); },
    isChangeOfInsuranceCompany() {
      const { InsuredPersonTypeEnum: enumeration } = this.enums;
      const { insuredPersonType } = this.person;
      return insuredPersonType === enumeration.CHANGE_OF_INSURANCE_COMPANY_ADULT || insuredPersonType === enumeration.CHANGE_OF_INSURANCE_COMPANY_CHILD;
    },
  },
  methods: {
    isSelected(option) {
      return this.person.insuredPersonType === option;
    },
    setInsuredPersonType(type) {
      const { InsuredPersonTypeEnum } = this.enums;
      this.person.insuredPersonType = type;
      this.person.childBornAbroad = null;

      if (type === InsuredPersonTypeEnum.CHANGE_OF_INSURANCE_COMPANY_ADULT || type === InsuredPersonTypeEnum.CHANGE_OF_INSURANCE_COMPANY_CHILD) {
        const firstOctober = new Date(`10/01/${this.today.getFullYear()}`);
        if (this.today < firstOctober) this.person.insuredFrom = formatDateForKotlin(new Date(`01/01/${this.today.getFullYear() + 1}`));
        else this.person.insuredFrom = formatDateForKotlin(new Date(`01/01/${this.today.getFullYear() + 2}`));
      } else this.person.insuredFrom = formatDateForKotlin(this.today);
      this.setFunnelSubType(this.insuredPersons);
    },
    formatDate(date) {
      return `${date.day}. ${date.month}. ${date.year}`;
    },
  },
};
</script>
